import React from 'react'
import {Marker} from 'react-leaflet'
import {divIcon} from 'leaflet'
import EstatePopup from './EstatePopup'

const groupIcon = (nbEstates) => divIcon({
  iconSize:[50,50],
  iconAnchor: [15,30],
  html: `
      <img src='/images/marker/marker-group.png'/>
      <div class="estate-group-count" style="position: absolute; top:0px; right: 4px;">${nbEstates}</div>
  `
});

const zoomOnBounds = (map, bounds) => _ => {
  const before = map.getZoom()
  map.fitBounds(bounds);
  const after = map.getZoom()
  if(after == before){
    map.zoomIn()
  }
}
const GroupMarker = ({map, coordinates, estates, bounds, children}) => {
  return <Marker position={coordinates} 
                 icon={groupIcon(estates.length)} 
                 onClick={zoomOnBounds(map, bounds)}/>
};

GroupMarker.propTypes = {
    bounds: React.PropTypes.object.isRequired,
    estates: React.PropTypes.array.isRequired,
    coordinates: React.PropTypes.shape({
      lat: React.PropTypes.number.isRequired,
      lng: React.PropTypes.number.isRequired
    }).isRequired,
};
export default GroupMarker;



/** WEBPACK FOOTER **
 ** ./app/components/GroupMarker.jsx
 **/